import { NSConsignment } from 'Pages/UserDashboard/Consignment/Consignment.d';
import { useFormik } from 'formik';

interface IUseTabToolbarForm {
  onSubmit?: (values: NSConsignment.IFormTabToolbar) => void;
}

export const useTabToolbarForm = (props: IUseTabToolbarForm) => {
  const form = useFormik<NSConsignment.IFormTabToolbar>({
    initialValues: {
      page: 1,
      keyword: '',
      sort_by: 'createdAt_desc',
    },
    onSubmit: (values) => {
      if (props.onSubmit) {
        props.onSubmit(values);
      }
    },
  });

  return {
    form,
  };
};
